// @flow

import React, { type Node } from 'react';
import { ThemeProvider } from 'styled-components';
import { type Theme } from './types';

type Props = {|
  theme: Theme,
  children: Node,
|};

export function VolcanesThemeProvider({ children, theme }: Props): Node {
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}
